<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="icao">
        <th mat-header-cell *matHeaderCellDef>ICAO</th>
        <td mat-cell *matCellDef="let element">{{ element.icao }}</td>
    </ng-container>

    <ng-container matColumnDef="fbo">
        <th mat-header-cell *matHeaderCellDef>FBO</th>
        <td mat-cell *matCellDef="let element">{{ element.fbo }}</td>
    </ng-container>

    <ng-container matColumnDef="pricingExpired">
        <th mat-header-cell *matHeaderCellDef>Pricing Expired</th>
        <td mat-cell *matCellDef="let element">
            <span [ngClass]="{ good: !element.pricingExpired }" class="status">
                {{ element.pricingExpired ? "Expired" : "Pricing Live" }}
            </span>
        </td>
    </ng-container>

    <ng-container matColumnDef="needAttentionCustomers">
        <th mat-header-cell *matHeaderCellDef>Need Attentions</th>
        <td mat-cell *matCellDef="let element">
            <span
                [ngClass]="{ good: element.needAttentionCustomers == 0 }"
                class="status"
            >
                {{ element.needAttentionCustomers }} Need Attentions
            </span>
        </td>
    </ng-container>

    <ng-container matColumnDef="lastLogin">
        <th mat-header-cell *matHeaderCellDef>Last Login Date</th>
        <td mat-cell *matCellDef="let element">
            {{ element.lastLogin | date : "medium" }}
        </td>
    </ng-container>

    <ng-container matColumnDef="users">
        <th mat-header-cell *matHeaderCellDef>Users</th>
        <td mat-cell *matCellDef="let element">
            {{ element.users.length }}
        </td>
    </ng-container>

    <ng-container matColumnDef="quotes30Days">
        <th mat-header-cell *matHeaderCellDef>Quotes (last 30 days)</th>
        <td mat-cell *matCellDef="let element">{{ element.quotes30Days }}</td>
    </ng-container>

    <ng-container matColumnDef="orders30Days">
        <th mat-header-cell *matHeaderCellDef>Fuel Orders (last 30 days)</th>
        <td mat-cell *matCellDef="let element">{{ element.orders30Days }}</td>
    </ng-container>

    <ng-container matColumnDef="accountExpired">
        <th mat-header-cell *matHeaderCellDef>Account Expired</th>
        <td mat-cell *matCellDef="let element">
            <span [ngClass]="{ good: !element.accountExpired }" class="status">
                {{ element.accountExpired ? "Inactive" : "Active" }}
            </span>
        </td>
    </ng-container>

    <ng-container matColumnDef="accountType">
        <th mat-header-cell *matHeaderCellDef>Account Type</th>
        <td mat-cell *matCellDef="let element">
            {{ element.accountType ? "Freemium" : "Premium" }}
        </td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
        <td mat-cell *matCellDef="let element">
            <button
                (click)="editFBO(element)"
                [view]="'warning'"
                beforeIcon="fa fa-pencil"
                clickStopPropagation
                ni-button
                size="small"
            >
                Edit FBO
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="manageFBO(row)"
    ></tr>
</table>
